export const TOAST_TYPE = {
	SUCCESS: "success",
	ERROR: "error",
	WARN: "warn"
};
